<script setup lang="ts">
import { computed } from 'vue'
import { RouterLink } from 'vue-router'
import { useConventionStore } from '@/stores/convention'
import emblemUrl from '@/assets/ww-emblem.png'

// The newspaper masthead: 3-col grid — left est/location sidenotes, center emblem + wordmark +
// motto, right edition + dates. Edition/dates come from the convention API at runtime; the coded
// placeholders keep the sheet honest before the API answers (or when it can't).
const conventionStore = useConventionStore()

const edition = computed(() => conventionStore.convention?.edition || 'Winter War 53')
const dates = computed(() => conventionStore.convention?.dateRange || 'Jan 29–31, 2027')
</script>

<template>
  <header class="bs-masthead">
    <div class="bs-masthead-left">
      <span>Established 1974</span>
      <span>Champaign, Illinois</span>
    </div>
    <div class="bs-masthead-center">
      <RouterLink to="/" class="bs-masthead-home">
        <img class="bs-emblem" :src="emblemUrl" alt="Winter War emblem — Ad Honorem" />
        <div class="bs-wordmark">Winter War</div>
      </RouterLink>
      <div class="bs-motto">
        The Midwest's Longest Consecutively Running Independent Gaming Convention
      </div>
    </div>
    <div class="bs-masthead-right">
      <span class="bs-edition">{{ edition }}</span>
      <span class="bs-dates">{{ dates }}</span>
    </div>
  </header>
</template>

<style scoped>
/* The emblem + wordmark act as one home link, without disturbing the masthead type. */
.bs-masthead-home {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: inherit;
  text-decoration: none;
}
</style>
